/* eslint-disable eqeqeq */
import React from "react";
import dayjs from "dayjs";
import KPIContainer from "./KPIContainer";
import { FinanceHoverIcon } from "../../../Common/Svgs/FinanceIcon";
import DistanceIcon from "../../../Common/Svgs/DistanceIcon";
import ClockIcon from "../../../Common/Svgs/ClockIcon";
import { BatteryPackIcon } from "../../../Common/Svgs/BatteryIcon";
import HubStationIcon from "../../../Common/Svgs/HubStationIcon";
import WatchIcon from "../../../Common/Svgs/WatchIcon";
import { RENTAL_STATUS, STANDARD_FEE } from "../constant";

const renderDuration = ({ details }) => {
  let hours = 0;
  let minutes = 0;

  const startTime = details?.startTime;
  const endTime = details?.endTime;

  if (startTime && endTime) {
    const differenceInMinutes = dayjs(endTime).diff(
      dayjs(startTime),
      "minutes",
    );

    hours = Math.floor(differenceInMinutes / 60);
    minutes = differenceInMinutes % 60;
  }

  return (
    <p>
      {hours ?? "--"} <span className="text-base">H </span>
      {minutes ?? "--"} <span className="text-base">M</span>
    </p>
  );
};

const renderSlot = ({ details }) => {
  const pickup = details?.pickupTime ? details.pickupTime.split(" ")[0] : "--";
  const dropoff = details?.dropoffTime
    ? details?.dropoffTime.split(" ")[0]
    : "--";
  const unit = details?.dropoffTime ? details?.dropoffTime.split(" ")[1] : "--";

  return (
    <p>
      {pickup} - {dropoff} <span className="text-base uppercase">{unit}</span>
    </p>
  );
};

const KPIs = ({ details }) => {
  const getTotalCost = () => {
    if (details?.status == RENTAL_STATUS.ONGOING) return "--";

    // no standard cost if the driver owns a trike
    const driverOwnsCurrentTrike = details?.driverTrikes?.length
      ? details?.driverTrikes?.some((d) => d.id == details?.trikeId)
      : false;

    // const standardCost = details?.driverTrikes?.length ? 0 : STANDARD_FEE;
    const standardCost = driverOwnsCurrentTrike ? 0 : STANDARD_FEE;

    const batteryCost = details?.batteries?.reduce((acc, current) => {
      const energy =
        parseFloat(current?.startEnergy || 0) -
        parseFloat(current?.endEnergy || 0);

      const cost = energy * parseFloat(current?.rate || 0);

      acc += cost;
      return acc;
    }, 0);

    const total = standardCost + batteryCost;
    return total ? `${parseFloat(total).toFixed(0)} KSH` : "--";
  };

  const getEnergyConsumed = () => {
    if (details?.status == RENTAL_STATUS.ONGOING) return "--";

    const start = details?.batteries?.reduce((acc, current) => {
      acc += parseFloat(current?.startEnergy || 0);
      return acc;
    }, 0);

    const end = details?.batteries?.reduce((acc, current) => {
      acc += parseFloat(current?.endEnergy || 0);
      return acc;
    }, 0);

    const consumed = parseFloat(start) - parseFloat(end);
    return consumed ? `${consumed.toFixed(1)} kWh` : "--";
  };

  return (
    <div className="w-full">
      <div className="flex items-center gap-x-2">
        <KPIContainer
          title="Total Cost"
          value={getTotalCost()}
          icon={
            <FinanceHoverIcon size={16} className="text-background-white" />
          }
        />

        <KPIContainer
          title="Total Distance"
          value="-- Km"
          icon={<DistanceIcon size={16} className="text-background-white" />}
        />

        <KPIContainer
          title="Trip Duration"
          value={renderDuration({ details })}
          icon={<ClockIcon className="text-background-white" />}
        />
      </div>

      <div className="mt-2 flex items-center gap-x-2">
        <KPIContainer
          title="Energy Consumed"
          value={getEnergyConsumed()}
          icon={<BatteryPackIcon className="text-background-white" />}
        />

        <KPIContainer
          title="Pickup Location"
          value={
            <p className="text-base capitalize">{details?.hubName || "--"}</p>
          }
          icon={<HubStationIcon className="text-background-white" />}
        />

        <KPIContainer
          title="Pickup & Drop-Off Time"
          value={renderSlot({ details })}
          icon={<WatchIcon size={20} className="text-background-white" />}
        />
      </div>
    </div>
  );
};

export default KPIs;
